let isNeedAssistant=["assistant"]
// let isNeedAssistant = [];

export default [
    {
        path: "/assistant/userManage",
        component: () => import("@/views/Assistant/user-manage/index"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant",
        component: () => import("@/views/Assistant/assistant/list"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/edit",
        name: "EditAssistant",
        component: () => import("@/views/Assistant/assistant/edit/index.vue"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/customsDate",
        name: "CustomsDate",
        component: () => import("@/views/Assistant/config-set/customsDate"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/checkOrder",
        name: "AssistantCheckOrder",
        component: () => import("@/views/Assistant/check-order/index.vue"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/marketPurchaseCode",
        name: "MarketPurchaseCode",
        component: () =>
            import("@/views/Assistant/normal-config/marketPurchaseCode"),
        meta: {
            experiences: isNeedAssistant,
            onlyCompany: true,
        },
    },
    {
        path: "/assistant/connectConfig",
        name: "ConnectConfig",
        component: () =>
            import("@/views/Assistant/normal-config/connectConfig"),
        meta: {
            experiences: isNeedAssistant,
            onlyCompany: true,
        },
    },
    {
        path: "/assistant/selfConfig",
        name: "SelfConfig",
        component: () => import("@/views/Assistant/normal-config/selfConfig"),
        meta: {
            experiences: isNeedAssistant,
            onlyCompany: true,
        },
    },
    {
        path: "/assistant/applicant",
        name: "Applicant",
        component: () => import("@/views/Assistant/config-set/applicant"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/consignee",
        name: "Consignee",
        component: () => import("@/views/Assistant/config-set/consignee"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/merchant",
        name: "Merchant",
        component: () => import("@/views/Assistant/config-set/merchant"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/passport",
        name: "Passport",
        component: () => import("@/views/Assistant/config-set/passport"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/supplier",
        name: "Supplier",
        component: () => import("@/views/Assistant/config-set/supplier"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/customsGoods",
        name: "CustomsGoods",
        component: () => import("@/views/Assistant/config-set/customsGoods"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/shipAgent",
        name: "ShipAgent",
        component: () => import("@/views/Assistant/config-set/shipAgent"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/goodDict",
        name: "GoodDict",
        component: () => import("@/views/Assistant/goods-dic/goodDict/list"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/goodDictOld",
        name: "goodDictOld",
        component: () => import("@/views/Assistant/goods-dic/goodDictOld"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/goodDictTable",
        name: "GoodDictTable",
        component: () => import("@/views/Assistant/goods-dic/goodDict/edit"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
            /** 规则包列表/保存 mode：1 多条简单规则；2 单主规则 + 多条子条件 */
            goodDictPackageMode: 1,
        },
    },
    {
        path: "/assistant/goodDictTableNew",
        name: "GoodDictTableNew",
        component: () => import("@/views/Assistant/goods-dic/goodDict/edit"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
            goodDictPackageMode: 2,
        },
    },
    {
        path: "/assistant/gNameToCodeTs",
        name: "GNameToCodeTs",
        component: () => import("@/views/Assistant/goods-dic/gNameToCodeTs"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/template",
        name: "TemplateList",
        component: () => import("@/views/Assistant/template/list"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/templateEdit",
        name: "TemplateEdit",
        component: () => import("@/views/Assistant/template/edit"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/staticData",
        name: "StaticData",
        component: () => import("@/views/Assistant/static-data/index"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
    {
        path: "/assistant/marketPurchaseAmount",
        name: "MarketPurchaseAmount",
        component: () =>
            import("@/views/Assistant/static-data/market-purchase/index"),
        meta: {
            experiences: isNeedAssistant,
            needCompanyRole: true,
        },
    },
];
